import { Component, Input, OnInit } from '@angular/core';
import { ClientService } from '../services/client.service';
import { AgreementService } from '../services/agreement.service';

@Component({
  selector: 'app-venue-widget',
  templateUrl: './venue-widget.component.html',
  styleUrls: ['./venue-widget.component.css']
})
export class VenueWidgetComponent implements OnInit {

  @Input() clientId: string = '';
  @Input() venues: ClientVenue[] = [];

  loadingAgreements: boolean = false;

  constructor(private agreementService: AgreementService) { }

  ngOnInit(): void {
    this.loadAgreements();
  }

  loadAgreements(): void {
    if (this.venues.length > 0) {
      this.venues.forEach(venue => {
        this.loadingAgreements = true;
        this.agreementService.getVenueAgreements(venue.kt_venue_id).subscribe({
          next: (res: VenueAgreementsResponse) => {
            venue.agreements = res.data;
            this.loadingAgreements = false;
          },
          error: (err) => {
            console.error(err);
            this.loadingAgreements = false;
          }
        });
      });
    }
  }

}
